import { useRef } from 'react';

export const useLatest = <T = any>(value: T) => {
  const latestRef = useRef<T>(value);
  return (latestRef.current = value), latestRef;
};
